module.exports = __webpack_public_path__ + "static/media/about-img-3@2x.23467e31.png";